import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


const OfferBanner = () => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [showOffer, setShowOffer] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const sessionDismissed = sessionStorage.getItem("offerBannerDismissed");
    if (!sessionDismissed) {
      const checkAndShow = () => {
        const consent = localStorage.getItem("cookieConsent");
        if (consent) {
          setHasLoaded(true);
          const timer = window.setTimeout(() => setShowOffer(true), 5000);
          return () => window.clearTimeout(timer);
        }
      };

      // Check immediately in case consent is already set
      checkAndShow();

      // Listen for custom event when cookie consent is set
      const handleConsentChange = () => {
        checkAndShow();
      };

      window.addEventListener("cookieConsentChanged", handleConsentChange);

      return () => {
        window.removeEventListener("cookieConsentChanged", handleConsentChange);
      };
    }
  }, []);

  const handleDismiss = () => {
    setShowOffer(false);
    sessionStorage.setItem("offerBannerDismissed", "true");
  };

  const handleGetStarted = () => {
    handleDismiss();
    navigate("/signup/recruiter");
  };

  if (!hasLoaded) return null;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-[999] bg-black/60 backdrop-blur-sm transition-opacity duration-500 ease-out ${
        showOffer ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
      }`}
    >
      <div
        className={`relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden transform transition duration-500 ease-out ${
          showOffer ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-6 scale-95"
        }`}
      >

        {/* Top accent bar */}
        <div className="h-1.5 w-full bg-gradient-to-r from-[#0350c6] via-[#FB9D05] to-[#EA4335]" />

        {/* Close button */}
        <button
          onClick={handleDismiss}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition text-gray-500 hover:text-gray-700 text-lg font-bold"
        >
          ✕
        </button>

        <div className="px-8 pt-6 pb-8">

          {/* Badge image */}
          <div className="flex justify-center mb-5">
            <img
              src="/free.avif"
              alt="Free Trial 30 Days"
              className="h-20 w-auto object-contain animate-[pulse_3s_ease-in-out_infinite] drop-shadow-[0_0_10px_rgba(220,38,38,0.6)]"
            />
          </div>

          {/* Heading */}
          <h2 className="text-2xl font-bold text-[#012760] text-center mb-1">
            Start Your Free 30-Day Trial
          </h2>
          <p className="text-center text-gray-500 text-sm mb-6">
            No credit card required. Cancel anytime.
          </p>

          {/* Credits highlight card */}
          <div className="bg-blue-50 border border-blue-100 rounded-xl px-5 py-4 mb-6 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-[#0350c6] flex items-center justify-center flex-shrink-0 text-white text-xl font-bold">
              ✦
            </div>
            <div>
              <p className="text-[#012760] font-bold text-base">1,000 Free Credits</p>
              <p className="text-gray-500 text-xs leading-relaxed">
                Post jobs, shortlist candidates & reach top talent — all included in your trial.
              </p>
            </div>
          </div>

          {/* Features list */}
          <ul className="space-y-2 mb-7">
            {[
              "Unlimited job postings for 30 days",
              "Access to verified candidate profiles",
              "Smart applicant tracking tools",
            ].map((item) => (
              <li key={item} className="flex items-center gap-2.5 text-sm text-gray-600">
                <span className="w-5 h-5 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-xs font-bold flex-shrink-0">
                  ✓
                </span>
                {item}
              </li>
            ))}
          </ul>

          {/* CTA Buttons */}
          <div className="flex gap-3">
            <button
              onClick={handleDismiss}
              className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-500 hover:bg-gray-50 transition"
            >
              Maybe Later
            </button>
            <button
              onClick={handleGetStarted}
              className="flex-1 px-4 py-2.5 bg-gradient-to-r from-[#FB9D05] to-[#EA4335] text-white rounded-xl text-sm font-semibold hover:opacity-90 transition shadow-md"
            >
              Claim Free Trial →
            </button>
          </div>

          <p className="text-center text-xs text-gray-400 mt-4">
            By continuing, you agree to our Terms & Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfferBanner;